export default __webpack_public_path__ + "static/media/xdai-logo.6a9ed7e3.png";